<template>
  <footer>
    <h1>
      {{ $t('footer.title') }}
    </h1>
    <div class="links-container">
      <ul>
        <li><a id="checkout-bottom-cta-perguntas-frequentes" :href="$t('footer.links.questions.url')" target="_blank">\ {{ $t('footer.links.questions.title') }}</a></li>
        <li><a id="checkout-bottom-cta-termos-de-uso" :href="$t('footer.links.termsOfUse.url')" target="_blank">\ {{ $t('footer.links.termsOfUse.title') }}</a></li>
        <li><a id="checkout-bottom-cta-politica-de-privacidade" :href="$t('footer.links.privacyPolicy.url')" target="_blank">\ {{ $t('footer.links.privacyPolicy.title') }}</a></li>
        <li><a id="checkout-bottom-cta-politica-de-seguranca" :href="$t('footer.links.informationSecurityPolicy.url')" target="_blank">\ {{ $t('footer.links.informationSecurityPolicy.title') }}</a></li>
        <li><a id="checkout-bottom-cta-politica-de-cookies" :href="$t('footer.links.cookiePolicy.url')" target="_blank">\ {{ $t('footer.links.cookiePolicy.title') }}</a></li>
      </ul>
      <a href="https://www.kidsafeseal.com/certifiedproducts/movile_playkids_app.html" target="_blank">
        <img border="0" alt="PlayKids - Learn Through Play is certified by the kidSAFE Seal Program."
        src="https://www.kidsafeseal.com/sealimage/392214569732409164/movile_playkids_app_extralarge_whitetm.png">
      </a>
    </div>
  </footer>
</template>

<script>
import { HOME_ROUTE } from '@/router/utils'
import { mapState } from 'vuex'

export default {
  name: 'pk-footer-component',
  props: {
    logout: Boolean
  },
  computed: {
    homeRoute() {
      return HOME_ROUTE
    },
    ...mapState({ isWebView: state => state.window.isWebView })
  }
}
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: column;
  height: 300px;
  padding: 0 0 0 1rem;
  background-color: #F7F7F7;
  border-top: solid 1px #453D4C;
  position: relative;

  h1 {
    font-family: Nunito;
    font-style: normal;
    font-weight: 900;
    font-size: 22px;
    line-height: 28px;
    color: #443D4B;

    margin-top: 3rem;
    margin-bottom: 2.5rem;
  }

  .links-container {
    position: relative;
    display: block;
    justify-content: space-between;
    align-items: flex-start;
    ul {
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      list-style-type: none;
      li {
        margin-bottom: 1em;
      }
    }

    a {
      font-family: Nunito;
      font-style: normal;
      font-weight: 900;
      font-size: 14px;
      line-height: 20px;
      color: #A217AB;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    img {
      margin-top: 1.5rem;
      width: 120px;
    }
  }
}
@media screen and (min-width: 641px) {
  footer {
    height: 340px;
    padding: 0 3rem 0 3rem;

    h1 {
      font-size: 34px;
      line-height: 34px;
      margin-top: 5rem;
    }
    .links-container {
      display: flex;
      flex-direction: column;
      ul {
        margin-top: 9rem;
        flex-direction: row;
        li {
          margin-bottom: 1em;
        }
      }
      a {
        font-size: 14px;
        line-height: 22px;
        margin-right: 2rem;
      }
      img {
        position: absolute;
        top: 0;
        width: 160px;
      }
    }
  }
}
@media screen and (min-width: 1281px) {
  footer {
    height: 280px;
    padding: 0 3rem 0 3rem;

    h1 {
      font-size: 39.81px;
      line-height: 40px;
      margin-bottom: 2rem;
    }
    .links-container {
      flex-direction: row;
      align-items: center;
      margin-top: 0;
      height: 60px;
      ul {
        margin-top: 2rem;
      }
      a {
        font-size: 20px;
        line-height: 31px;

        margin-right: 3rem;
        margin-bottom: 0;
      }
      img {
        position: relative;
        top: 0;
        width: 160px;
      }
    }
  }
}
</style>
